import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { NgClass, NgOptimizedImage, NgStyle } from '@angular/common';

import { PreloadImageDirective } from '@directives/preload-image.directive';

@Component({
  selector: 'app-image',
  imports: [NgClass, NgOptimizedImage, NgStyle, PreloadImageDirective],
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
})
export class ImageComponent implements OnChanges {
  @Input() src?: string;
  @Input() srcset?: string;
  @Input() sizes?: string;
  @Input() alt: string = '';
  @Input('full-width') fullWidth: boolean = false;
  @Input('full-height') fullHeight: boolean = false;
  @Input() width?: string | number;
  @Input('min-width') minWidth?: string | number;
  @Input('max-width') maxWidth?: string | number;
  @Input() height?: string | number;
  @Input('min-height') minHeight?: string | number;
  @Input('max-height') maxHeight?: string | number;
  @Input() fill?: boolean;
  @Input('object-fit') objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
  @Input('object-position') objectPosition?: string;
  @Input() optimized: boolean = true;
  @Input() priority: boolean = false;
  @Input() placeholder: boolean | string = true;
  @Input('preload-image-parent') preloadImageParent?: string;
  @Input('border-radius') borderRadius?: 'default' | 'small' | 'min';
  @Input('circle') circle?: boolean;
  @Output() loaded: EventEmitter<void> = new EventEmitter<void>();

  load(): void {
    this.loaded.emit();
  }

  ngOnChanges(): void {
    if (this.src && this.src.endsWith('.svg')) this.placeholder = false;
    if (typeof this.minWidth === 'number') this.minWidth = this.minWidth + 'px';
    if (typeof this.maxWidth === 'number') this.maxWidth = this.maxWidth + 'px';
    if (typeof this.minHeight === 'number') this.minHeight = this.minHeight + 'px';
    if (typeof this.maxHeight === 'number') this.maxHeight = this.maxHeight + 'px';
  }
}
